<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="8" v-if="Detail.employmentCompany">
        <span class="label">用工单位:</span>
        <span class="context">{{Detail.employmentCompany}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.projectName">
        <span class="label">项目名称:</span>
        <span class="context">{{Detail.projectName}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.projectName">
        <span class="label">薪资方式:</span>
        <span class="context" v-if="Detail.salaryType==4||Detail.salaryType==5||Detail.salaryType==6">
          {{Detail.salaryTypeName? Detail.salaryTypeName: "/"}}
        </span>
        <span v-if="Detail.salaryType==1||Detail.salaryType==2||Detail.salaryType==3" class=" color3">/</span>
      </el-col>
      <el-col :span="8" v-if="Detail.salaryType==4" :style="Detail.sysTeamCategory&&Detail.sysTeamCategory.replace(/[^\x00-\xff]/g, '00').length>48?'height:40px':'height:19px'">
        <span class="label" style="min-width:50px">任务量:</span>
        <span class="context">{{Detail.taskVolume}}{{Detail.taskVolumeUnit}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label" style="min-width:60px">工种名称:</span>
        <span class="context single_hide" :title="Detail.sysTeamCategory">{{Detail.sysTeamCategory?Detail.sysTeamCategory:'/'}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label">专业要求:</span>
        <span class="context single_hide" :title="Detail.industryName">{{ Detail.industryName }}{{Detail.categoryName ? "/" + Detail.categoryName : ""}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.workTypeName">
        <span class="label">所需工种:</span>
        <div @mouseenter="handleShowTooltip($event)">
          <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
            <div class="context single_hide" style="color: #333;max-width:295px">{{Detail.workTypeName}}</div>
            <div slot="content"  style="color: #666;font-family: Microsoft YaHei;">{{Detail.workTypeName}}</div>
          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="8" v-if="Detail.imName">
        <span class="label">客服:</span>
        <span class="context">{{Detail.imName}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.provinceName">
        <span class="label">工作地址:</span>
        <div @mouseenter="handleShowTooltip($event)">
          <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
            <div class="context single_hide" style="color: #333;max-width:300px">{{ Detail.provinceName}}{{ Detail.cityName}}{{ Detail.areaName}}{{ Detail.address}}</div>
            <div slot="content"  style="color: #666;font-family: Microsoft YaHei;">{{ Detail.provinceName}}{{ Detail.cityName}}{{ Detail.areaName}}{{ Detail.address}}</div>
          </el-tooltip>
        </div>
      </el-col>
      <!-- <el-col :span="8" v-if="Detail.duration">
        <span class="label">用工时间:</span>
        <span class="context">{{Detail.duration}}{{Detail.durationUnitName}}</span>
      </el-col> -->
      <el-col :span="8" v-if="Detail.stayCondition">
        <span class="label">住宿条件:</span>
        <span class="context">{{Detail.stayCondition}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.dietCondition">
        <span class="label">饮食条件:</span>
        <span class="context">{{Detail.dietCondition}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.salaryManager">
        <span class="label">薪资管理:</span>
        <span class="context">{{'、保底工资、绩效方式、'.split('、')[Detail.salaryManager]}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.payRoll">
        <span class="label">薪资发放:</span>
        <span class="context">{{'、按月、按季度、按年度'.split('、')[Detail.payRoll]}}</span>
      </el-col>
      <el-col :span="8" v-if="Detail.professClothing">
        <span class="label">专业服装:</span>
        <span class="context">{{Detail.professClothing}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" v-if="Detail.employmentDescription" style="line-height:22px;margin-top:0px">
        <span class="label" style="min-width:60px">工作内容:</span>
        <span class="context" style="white-space: pre-wrap">{{Detail.employmentDescription}}</span>
      </el-col>
      <el-col :span="24" v-if="Detail.fileDTOList&&Detail.fileDTOList.length">
        <span class="label" style="margin-right:5px">用工图片:</span>
        <span class="context">
          <el-image
            v-for="(img,index) in Detail.fileDTOList"
            :key="index"
            :src="img.url"
            :preview-src-list="[img.url]"
            fit="cover"
          ></el-image>
        </span>
      </el-col>
      <template v-if="Detail.workerFieldList&&Detail.workerFieldList.length">
      <el-col :span="24" v-for="item in Detail.workerFieldList" :key="item.name" class="detail-item" style="line-height:22px">
        <span class="item-name" >{{ item.name }}:</span>
        <span class="item-value">{{item.content}}</span>
      </el-col>
      </template>
      <el-col :span="24" class="detail-item" style="display: flex;padding-bottom: 0;margin-bottom:0"
              v-if="Detail.fileList && Detail.fileList.length">
        <span class="c666 item-name" >附件:</span>
        <span style="display:flex;flex-wrap: wrap">
            <div v-for="(file,index) in Detail.fileList" :key="index" class="file-item">
              <div class="file-item-container">
                  <img :src="fileIcon[file.name.split('.').pop().toLowerCase()]" alt="" class="file-icon">
                  <div class="file-info">
                    <div class="file-name">
                      <div class="fore">{{ file.name.slice(0, file.name.lastIndexOf('.')) }}</div>
                      <div class="back">.{{ file.name.split('.').pop() }}</div>
                    </div>
                    <div class="file-other">
                      <span class="file-size">{{ formatFileSize(file.size) }}</span>
                      <span class="file-download" @click="$previewFile(file.fileUrl)">预览</span>
                    </div>
                  </div>
                </div>
              </div>
          </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/utils/previewFile'
export default {
  data() {
    return {
      showTooltip:false,
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png")
      }
    }
  },
  props: {
    Detail: {
      type: Object
    }
  },
  components: {},
  methods: {
     formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize /1024 > 10) {
        return `${(fileSize /1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
    //内容超出时,hover显示所有文本信息
    handleShowTooltip(event){
      let cell = event.target.querySelector('.el-tooltip');
      this.showTooltip = cell.scrollWidth === cell.offsetWidth;
    },
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.detail-item {
    display: flex;
    .item-name {
      font-size: 14px;
      flex-shrink: 0;
      color: var(--FC6);
      margin-right: 3px;
    }
    .item-value {
      color: #333;
      font-size: 14px;
    }
  }
  .file-item {
    .file-item-container {
      box-sizing: border-box;
      width: 236px;
      display: flex;
      padding:10px;
      margin:0px 10px 10px 0px ;
      background-color: #FAFAFA;
      font-size: 14px;
      border-radius: 4px;
      .file-icon {
        width: 33px;
        height: 40px;
      }
      .file-info {
        flex: 1;
        padding-left: 10px;
        line-height: 1.2;
        .file-name {
          margin-bottom: 10px;
          display: flex;
          color: var(--FC3);
          .fore {
            max-width: 148px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .back{
            flex-shrink: 0;
          }
        }
        .file-other {
          display: flex;
          justify-content: space-between;
          .file-size {
            color: var(--FC9);
          }
          .file-download {
            cursor: pointer;
            color: #0286df;
          }
        }
      }
    }
  }
  .single_hide {
      // 单行隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
</style>
<style lang="scss" rel="stylesheet/scss">
.popperCustoms {
  padding: 5px 10px!important;
  &.is-light {
    background: #ffffff !important;
    border: 1px solid #666666;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0;
    opacity: 1 !important;
    color: #666666 !important;
  }
}
</style>
